import { useCallback } from 'react';

import { fetchRtpAction } from '../apiActions/fetchRtpAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useRtpFetcherConnected = (essential: boolean): (() => void) => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const baseUrl = useConfigSlice.baseUrl();
  const tableConfigTableVariant = useConfigSlice.getTableVariant()?.toLowerCase();
  const gameType = useConfigSlice.getGameType()?.toLowerCase();
  const tableVariant = tableConfigTableVariant || gameType;
  const rtp = useConfigSlice.getRtp();

  return useCallback(() => {
    if (JSESSIONID && tableVariant && baseUrl && !rtp) {
      dispatch(
        fetchRtpAction({
          JSESSIONID,
          tableVariant,
          url: `${baseUrl}/api/ui/getRtpDetails`,
          essential,
        })
      );
    }
  }, [JSESSIONID, baseUrl, dispatch, essential, rtp, tableVariant]);
};
